import _ from 'underscore';
import { deprecatedReports } from '@bingads-webui-campaign/reports-v4-schema';
import { showError, getDeprecatedMessage } from '@bingads-webui-campaign/report-shared';
import createSimilarReportEmailRule from '@bingads-webui-campaign-legacy/inline-download-reports/create-similar';
import { downloadReportEmailRule, deleteReportEmailRules } from '@bingads-webui-campaign-legacy/griddownload/view/loader';
import { notificationApi } from '@bingads-webui-campaign/notification-center';
import { isReportTemplateType } from './shared';

export default ({
  i18n,
  onActionSuccess,
  resetSelection,
  legacyI18n,
  scopeHistoryPush,
  getUrlSearch,
  convertSelectionDateRangeToDateFilter,
  restoreDateFilter,
  serverContext,
  iframeDownload,
  history,
  rerunReport,
  deleteReports,
}) => ({
  duplicate: (selectedItems) => {
    const taskItem = selectedItems[0];
    const {
      ReportType,
      Id,
      Type,
    } = taskItem;

    if (isReportTemplateType(Type)) {
      if (deprecatedReports[ReportType]) {
        showError(getDeprecatedMessage(ReportType, i18n));
      } else {
        history.push({
          pathname: `/campaign/vnext/reports-v4/edit/${Id}`,
          search: location.search + (Type === 'ReportUITemplate' ? '&type=ReportUITemplate' : ''),
        });
      }
    } else {
      createSimilarReportEmailRule(Id, {
        isForNewUI: true,
        scopeHistoryPush,
        getUrlSearch,
        i18n: legacyI18n,
        convertSelectionDateRangeToDateFilter,
        restoreDateFilter,
        serverContext,
      });
    }
  },

  download: async (selectedItems) => {
    const taskItem = selectedItems[0];
    const {
      ReportType,
      Type,
    } = taskItem;

    resetSelection();
    if (isReportTemplateType(Type)) {
      if (deprecatedReports[ReportType]) {
        showError(getDeprecatedMessage(ReportType, i18n));
      } else {
        notificationApi.showInfo(i18n.getString(_TL_('We are creating your report and it will be downloaded shortly.')), {
          autoDismissTime: 5000,
        });
        try {
          const res = await rerunReport(taskItem);
          iframeDownload(res.ResultId);
        } catch (error) {
          notificationApi.showWarning(i18n.getString(_TL_('We\'ve encountered an error. Please try again or contact support.')), {
            autoDismissTime: 5000,
          });
        }
      }
    } else {
      downloadReportEmailRule(taskItem).catch((err) => {
        showError(err.message);
      });
    }
  },

  del: (selectedItems) => {
    // eslint-disable-next-line
    if (confirm(i18n.getString(_TL_('Are you sure you want to delete the selected items?')))) {
      const {
        reportTemplates,
        inlineDownloadReports,
      } = _.groupBy(selectedItems, ({ Type }) => (isReportTemplateType(Type) ? 'reportTemplates' : 'inlineDownloadReports'));

      const deleteReportTemplates = !_.isEmpty(reportTemplates) && deleteReports(reportTemplates);

      const deleteInlineDownloadReports = !_.isEmpty(inlineDownloadReports) && deleteReportEmailRules(inlineDownloadReports);

      resetSelection();
      return Promise.all([deleteReportTemplates, deleteInlineDownloadReports])
        .then(() => {
          onActionSuccess();
          return null;
        })
        .catch((err) => {
          showError(err.message || JSON.stringify(err.errors[0]));
        });
    }

    return Promise.resolve();
  },
});

